import { Injectable } from '@angular/core';
import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class CommonUtilService {

  constructor() { }

  toCamel(s: string) {
    return s.replace(/([-_][a-z])/ig, ($1) => {
      return $1.toUpperCase()
        .replace('-', '')
        .replace('_', '');
    });
  }

  keysToCamel(o: any) {
    if (o === Object(o) && !Array.isArray(o) && typeof o !== 'function') {
      const n = {};
      Object.keys(o)
        .forEach((k) => {
          n[this.toCamel(k)] = this.keysToCamel(o[k]);
        });
      return n;
    } else if (Array.isArray(o)) {
      return o.map((i) => {
        return this.keysToCamel(i);
      });
    }
    return o;
  }

  createDateObject(ngbDate: NgbDateStruct, ngbTime?: NgbTimeStruct): Date {
    const today = new Date();
    if (ngbDate) {
      today.setFullYear(ngbDate.year);
      today.setMonth(ngbDate.month - 1);
      today.setDate(ngbDate.day);
      today.setUTCHours(ngbTime ? ngbTime.hour : 12);
      today.setMinutes(ngbTime ? ngbTime.minute : 0);
      today.setSeconds(ngbTime ? ngbTime.second : 0);
      today.setMilliseconds(0);
    }
    return today;
  }

  public checkIfDateIsWithinGivenDays(date: Date, numberOfDaysToCheck: number) {
    const givenDate = new Date(date);
    const today = new Date();
    const numberOfDaysBetween = Math.abs(givenDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24);

    return numberOfDaysBetween < numberOfDaysToCheck;
  }

}
